export * from "./QuoteCaption.js";
